import { render } from "./ParallaxComponent.vue?vue&type=template&id=7c3fc730"
import script from "./ParallaxComponent.vue?vue&type=script&lang=js"
export * from "./ParallaxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__